var render, staticRenderFns
import script from "./formatterAutoMV.vue?vue&type=script&lang=js&"
export * from "./formatterAutoMV.vue?vue&type=script&lang=js&"
import style0 from "./formatterAutoMV.vue?vue&type=style&index=0&id=95130bac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95130bac",
  null
  
)

export default component.exports